<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <billing-table :title="$t('billing')"></billing-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import BillingTable from './Tables/BillingTable'
  export default {
    name: 'billing',
    components: {
      BillingTable
    }
  }
</script>
<style></style>
